import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";

const { actions: actionsCopy } = copy;

export const getMemberSettingsActions = ({
  handleEdit,
}: {
  handleEdit: () => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [
    {
      label: actionsCopy.edit,
      handleClick: handleEdit,
      dataTestId: "edit_member_settings",
    },
  ];

  return actions;
};
